import { defaultLanguage } from 'cf-i18n/constants'

/**
 * Prefixes an app-internal path with the locale being served.
 *
 * Mirrors the `localePrefix: 'as-needed'` that `proxy.ts` configures its
 * next-intl middleware with: the default language is unprefixed, everything else
 * carries its segment.
 */
export function localeHref(path: string, locale: string): string {
  if (locale === defaultLanguage || !path.startsWith('/')) {
    return path
  }

  if (path === `/${locale}` || path.startsWith(`/${locale}/`)) {
    return path
  }

  // `/` would otherwise become `/fr/`, which the middleware redirects away from.
  return path === '/' ? `/${locale}` : `/${locale}${path}`
}
